/* eslint no-console: "error" */
import axios from "../../utils/axios";

const getDefaultState = () => {
    return {
        sailink_data: null,
        quotaData: null,
        alert: null,
        mrtg: null,
        showmaptable: null,
        vesselUsers: null,
        showmaptracking: null,
        showmapclick: null,
        rangeshowmap: null,
        tableTracking: null,
        ip_adr: null,
        ln_status: null,
        weather_data: null,
        searchVessel: null,
        searchVesselID: null,
        mrtgopen: null,
        status_mrtg: null,
        nameopen: null,
        message_name: null,
        color_name: null,
        nameData: null,
        nameChangeData: null,
        icon_name: null,
        msg_name: null,
        nmopen: null,
        alertColor: null,
        tlpopen: null,
        StaticName: null,
        notifopen: null,
        startFrom: false,
        notifData: null,
        serviceQuota: null,
        hovershowmap: null,
        sailink_executed: false,
        thuraya_executed: false,
        manifest_executed:false,
        notifID:null,
    }
}

const state = getDefaultState();

const getters = {
    quotaData: (state) => state.quotaData,
    sailinkData: (state) => state.sailink_data,
    alertSailink: (state) => state.alert,
    mrtgSailink: (state) => state.mrtg,
    showmaptable: (state) => state.showmaptable,
    vesselUsers: (state) => state.vesselUsers,
    showmaptracking: (state) => state.showmaptracking,
    showmapclick: (state) => state.showmapclick,
    rangeshowmap: (state) => state.rangeshowmap,
    tableTracking: (state) => state.tableTracking,
    ip_adr: (state) => state.ip_adr,
    ln_status: (state) => state.ln_status,
    weather_data: (state) => state.weather_data,
    searchVessel: (state) => state.searchVessel,
    searchVesselID: (state) => state.searchVesselID,
    mrtgopen: (state) => state.mrtgopen,
    status_mrtg: (state) => state.status_mrtg,
    hovershowmap: (state) => state.hovershowmap,
    sailink_executed: (state) => state.sailink_executed,
    nameopen: (state) => state.nameopen,
    message_name: (state) => state.message_name,
    color_name: (state) => state.color_name,
    nameData: (state) => state.nameData,
    nameChangeData: (state) => state.nameChangeData,
    icon_name: (state) => state.icon_name,
    msg_name: (state) => state.msg_name,
    nmopen: (state) => state.nmopen,
    alertColor: (state) => state.alertColor,
    tlpopen: (state) => state.tlpopen,
    StaticName: (state) => state.StaticName,
    notifopen: (state) => state.notifopen,
    startFrom: (state) => state.startFrom,
    notifData: (state) => state.notifData,
    serviceQuota: (state) => state.serviceQuota,
    thuraya_executed: (state) => state.thuraya_executed,
    manifest_executed:(state)=>state.manifest_executed,
    notifID:(state)=>state.notifID
};

const actions = {
  
    async fetchMySailink({commit}, data) {
       
        const response = await axios.get(
            "/api/v1/navplus/sailink",
            {
                headers: {
                    Authorization: "Bearer" + data,
                },
            }
        );
        commit(
            "setMySailink",
            response.data.data.vessels.map((item, index) =>
                Object.assign(item, {index})
            )
        );
    },

    unsetMySailink({commit}){
        commit("setMySailink",null);
    },

    async fetchMRTG({commit}, data) {
        commit("setmrtgopen", true);
        const response = await axios.get(
            "/api/v1/navplus/sailink/mrtg/" + data.id + "/" + data.mrtg,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        //console.log(response);
        commit("setMRTG", response.data.data);
        commit("setstatus_mrtg", data.status_mrtg);

    },


    async vnameFetchSailink({commit},data){
        commit("setnmopen", true);
        commit("setnameopen", true)
        try{
            const response = await axios.get(
                "/api/v1/navplus/vessel/name/" +
                  data.id ,
                {
                  headers: {
                    Authorization: "Bearer" + data.token,
                  },
                }
              );
              console.log(response.data.data);
              commit("setnameDataSailink",response.data.data)
        }catch(e){
            console.log(e)
        }
    },


    async notifPost({commit}, data) {
        const datanotif = {
            enabled:data.enabled,
            batas:data.batas,
            emails:data.emails,
        };
        const response = await axios.post(
          "/api/v1/navplus/email/limit/"+data.id,
          datanotif,
          {
            headers: {
              Authorization: "Bearer" + data.token,
            },
          }
        );
        console.log(response);
        commit("setnotifData", response.data.data)
    },

    async fetchNotif({commit}, data) {
        console.log(data.id)
        commit("setnotifID", data.id)
        commit("setnotifopen", true)
        const response = await axios.get(
            "/api/v1/navplus/email/limit/" + data.id ,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );

        commit("setnotifData", response.data.data)
        
    },


    removeNotif({commit}) {
        commit("setnotifData", null)
        commit("setnotifopen", null)
    },

    removeMRTG({commit}) {
        commit("setMRTG", null);
        commit("setmrtgopen", null);
        commit("setstatus_mrtg", null);
    },

    addsailink_executed({commit}, data) {
        commit("setsailink_executed", data)
    },

    addthuraya_executed({commit}, data) {
        commit("setthuraya_executed", data)
    },

    addmanifest_executed({commit},data){
        commit("setmanifest_executed", data)
    },

    async updateVesselName({commit}, data) {
        const dataName = {
            id: data.id,
            name: data.name,
        };
        //console.log(dataName)
        const response = await axios.post(
            "/api/v1/navplus/vessel/name",
            dataName,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );

        //console.log(response);
        commit("setAlert", response.data.message);
        commit("seticon_name", 'mdi-check-circle');

        if (response.data.message == 'Retrieved successfully') {
            commit("setalertColor", 'green');
            commit("setmsg_name", 'Name update sucsessfully');
        } else if (response.data.message != 'Retrieved successfully') {
            commit("setalertColor", 'yellow');
            commit("setmsg_name", 'Cant change the name check the data');
        } else {
            commit("setalertColor", 'red');
            commit("setmsg_name", 'Please check your connection');
        }
    },

    setDataName({commit}, data) {
        //console.log('JALAN KOK yang ke dua')
        //console.log(data)
        commit("setnmopen", true);
        commit("setnameopen", true)
        commit("setnameDataSailink", data);
        commit("setnameChangeData", data.name);
        //console.log('macet')
    },

    setUpStaticName({commit}, data) {
        commit("setStaticName", data)
    },


    removeName({commit}) {
        commit("setnameopen", null)
        commit("setnmopen", null);
        commit("setnameDataSailink", null);
        commit("setnameChangeData", null);
        commit("setAlert", null);
        commit("seticon_name", null);
        commit("setcolor_name", null);
        commit("setmsg_name", null);
    },

    async showonMapSailink({commit}, data) {
        commit("setshowmaptable", null);
        commit("setvesselUsers", null);
        commit("settableTracking", null);
        commit("setQuotaData", null);
        const response = await axios.get(
            "/api/v1/navplus/sailink/" + data.id,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );

        var dataTable = await response.data.data

        commit("setshowmaptable", dataTable);
        commit(
            "setvesselUsers",
            dataTable.vesselUsers.map((item, index) =>
                Object.assign(item, {index})
            )
        );
        commit(
            "settableTracking",
            dataTable.dataTable.map((item, index) =>
                Object.assign(item, {index})
            )
        );
    },

    async ipAdr({commit}, data) {
        commit("setip_adr", null);
        const response = await axios.get(
            "/api/v1/navplus/sailink/" + data.id + "/fetchIp",
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );

        commit("setip_adr", await response.data.data);
    },

    async lnStatus({commit}, data) {
        commit("setln_status", null);
        const response = await axios.get(
            "/api/v1/navplus/sailink/" + data + "/fetchStatus",
            {
                headers: {
                    Authorization: "Bearer" + localStorage.getItem("token"),
                },
            }
        );
        commit("setln_status", await response.data.data);
    },

    async showondate({commit}, data) {
        commit("setshowmaptracking", null);
        const datadate = {
            id: data.id,
            range: data.range,
        };
        const response = await axios.post(
            "/api/v1/navplus/sailink/date",
            datadate,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        commit("setshowmaptracking", await response.data.data);

        commit(
            "settableTracking",
            response.data.data.dataTable.map((item, index) =>
                Object.assign(item, {index})
            )
        );
    },

    async showweather({commit}, data) {
        commit("setweather_data", null);
        const datawth = {
            id: data.id,
            msg_id: data.msg_id,
            type: data.type,
        };
        const response = await axios.post(
            "/api/v1/navplus/weather/fetchRow",
            datawth,
            {
                headers: {
                    Authorization: "Bearer" + localStorage.getItem("token"),
                },
            }
        );
        //console.log(response);
        commit("setweather_data", await response.data.data);
    },

    searchVesselInput({commit}, data) {
        commit("setsearchVessel", data);
    },

    searchVesselID_Input({commit}, data) {
        commit("setsearchVesselID", data);
    },

    removeSearch({commit}) {
        commit("setsearchVessel", null);
    },

    removeShowMap({commit}) {
        commit("setshowmaptable", null);
        commit("setvesselUsers", null);
        commit("settableTracking", null);
        commit("setshowmapclick", null);
        commit("setsearchVessel", null);
        commit("setsearchVesselID", null);
    },

    addShowClick({commit}) {
        commit("setshowmapclick", true);
    },

    fetchTlOpen({commit}) {
        commit("settlpopen", true)
    },

    removetl({commit}) {
        commit("settlpopen", null)
    },

    async fetchQuota({commit}, data) {
        commit("setservicequota", data.service)
        const response = await axios.get(
            "/api/v1/navplus/sailink/fetchNfaMonthly/" + data.vessel_id + "/" + data.service + "",
            {
                headers: {
                    Authorization: "Bearer" + localStorage.getItem("token"),
                },
            }
        );
        //console.log(response)
        commit("setQuotaData", await response.data.data);
    },

    removeQuota({commit}) {
        commit("setQuotaData", null);
        commit("setservicequota", null);
    },

    resetMysailinkState({commit}) {
        commit("resetState");
    },
};

const mutations = {
    setthuraya_executed: (state, thuraya_executed) => (state.thuraya_executed = thuraya_executed),
    setMySailink: (state, mysailink) => (state.sailink_data = mysailink),
    setsailink_executed: (state, sailink_executed) => (state.sailink_executed = sailink_executed),
    updateMySailink: (state, mysailink) => (state.sailink_data = mysailink),
    setMRTG: (state, mrtg) => (state.mrtg = mrtg),
    setAlert: (state, alert) => (state.alert = alert),
    setshowmaptable: (state, showmaptable) => (state.showmaptable = showmaptable),
    setvesselUsers: (state, vesselUsers) => (state.vesselUsers = vesselUsers),
    settableTracking: (state, tableTracking) =>
        (state.tableTracking = tableTracking),
    setip_adr: (state, ip_adr) => (state.ip_adr = ip_adr),
    setln_status: (state, ln_status) => (state.ln_status = ln_status),
    setshowmaptracking: (state, showmaptracking) =>
        (state.showmaptracking = showmaptracking),
    setweather_data: (state, weather_data) => (state.weather_data = weather_data),
    setsearchVessel: (state, searchVessel) => (state.searchVessel = searchVessel),
    setsearchVesselID: (state, searchVesselID) =>
        (state.searchVesselID = searchVesselID),
    setshowmapclick: (state, showmapclick) => (state.showmapclick = showmapclick),
    setmrtgopen: (state, mrtgopen) => (state.mrtgopen = mrtgopen),
    setstatus_mrtg: (state, status_mrtg) => (state.status_mrtg = status_mrtg),
    setnameopen: (state, nameopen) => (state.nameopen = nameopen),
    setnameDataSailink: (state, nameData) => (state.nameData = nameData),
    setnameChangeData: (state, nameChangeData) => (state.nameChangeData = nameChangeData),
    seticon_name: (state, icon_name) => (state.icon_name = icon_name),
    setcolor_name: (state, color_name) => (state.color_name = color_name),
    setmsg_name: (state, msg_name) => (state.msg_name = msg_name),
    setnmopen: (state, nmopen) => (state.nmopen = nmopen),
    setalertColor: (state, alertColor) => (state.alertColor = alertColor),
    settlpopen: (state, tlpopen) => (state.tlpopen = tlpopen),
    setStaticName: (state, StaticName) => (state.StaticName = StaticName),
    setnotifopen: (state, notifopen) => (state.notifopen = notifopen),
    setstartFrom: (state, startFrom) => (state.startFrom = startFrom),
    setnotifData: (state, notifData) => (state.notifData = notifData),
    setnotifID:(state, notifID) => (state.notifID =  notifID),
    setQuotaData: (state, quotaData) => (state.quotaData = quotaData),
    setservicequota: (state, serviceQuota) => (state.serviceQuota = serviceQuota),
    sethovershowmap: (state, hovershowmap) => (state.hovershowmap = hovershowmap),
    setmanifest_executed:(state,manifest_executed)=>(state.manifest_executed = manifest_executed),
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
